import {Component, OnInit} from '@angular/core';
import {NotificationService} from "../../services/notifications/notification.service";

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  constructor(
    private notifyService: NotificationService) {
  }

  ngOnInit() {
  }

}
